import { module } from 'modujs'
import modularLoad from 'modularload'
import { CUSTOM_EVENT } from '../config'
import { resetLazyloadCallbacks, triggerLazyloadCallbacks } from '../utils/image'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 250,
            transitions: {
                listing: {
                    loadingClass: 'is-loading-transition-listing',
                    enterDelay: 250
                }
            }
        })

        const readyEvent = new CustomEvent(CUSTOM_EVENT.READY)

        this.load?.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')
            window.dispatchEvent(readyEvent)

            if (transition === 'listing') {
                this.call('addScrollElements', newContainer, 'Scroll')

                setTimeout(() => {
                    const scrollToDuration = 0.5
                    this.call('scrollTo', { target: '.c-filters', offset: -120, duration: scrollToDuration }, 'Scroll')

                    setTimeout(() => {
                        this.call('unlockReduced', null, 'Header')
                    }, scrollToDuration * 1000)
                }, 100);
            }

            /**
             * Trigger lazyload
             */
            triggerLazyloadCallbacks()
        })

        this.load?.on('loading', (transition, oldContainer) => {

            resetLazyloadCallbacks()

            if(transition === 'listing') {
                this.call('removeScrollElements', oldContainer, 'Scroll')
                this.call('lockReduced', true, 'Header')
            } else {
                this.call('start', null, 'Loader')
            }

        })
    }

    goTo(obj) {
        this.load?.goTo(obj.url, obj.transition)
    }
}
